import React from 'react';

interface IProps {
  style?: any;
}

const ZoomMinusIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="none"><rect id="backgroundrect" width="100%" height="100%" x="0" y="0" fill="none" stroke="none"/>
      <defs>
      <filter id="filter0_d" x="0" y="0" width="45.3671989440918" height="45.367698669433594" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
      <feFlood floodOpacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset/>
      <feGaussianBlur stdDeviation="7.5"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
      </defs>
      <g><title>Layer 1</title><g filter="url(#filter0_d)" id="svg_1">
      <path d="M7.6838000000000015,0 C3.446999999999999,0 0,3.446999999999999 0,7.6838000000000015 C0,11.9207 3.446999999999999,15.3676 7.6838000000000015,15.3676 C11.9207,15.3676 15.3676,11.9207 15.3676,7.6838000000000015 C15.3676,3.446999999999999 11.9207,0 7.6838000000000015,0 z" fill="#818181" id="svg_2"/>
      <path d="M10.549399999999999,7 H5.4269 C5.191099999999999,7 5,7.223800000000001 5,7.5 C5,7.776199999999999 5.191099999999999,8 5.4269,8 H10.549399999999999 C10.7852,8 10.976299999999998,7.776199999999999 10.976299999999998,7.5 C10.976299999999998,7.223800000000001 10.7852,7 10.549399999999999,7 z" fill="white" id="svg_3"/>
      </g></g>
    </svg>
  )
}

export default ZoomMinusIcon;